import { Star } from 'lucide-react';
import { useIsFavorite, useToggleFavorite } from '@/hooks/useFavorites';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';

interface FavoriteButtonProps {
  targetId: string;
  targetType: 'project' | 'agent' | 'prompt' | 'tool';
  className?: string;
  size?: number;
}

export const FavoriteButton = ({ targetId, targetType, className, size = 16 }: FavoriteButtonProps) => {
  const isFavorite = useIsFavorite(targetId);
  const toggleFavorite = useToggleFavorite();
  

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleFavorite.mutate(
      { targetId, targetType },
      {
        onSuccess: (result) => {
          toast.success(result.action === 'added' ? 'Adicionado aos favoritos' : 'Removido dos favoritos');
        },
        onError: (err: Error) => {
          toast.error(`Erro ao atualizar favorito: ${err.message}`);
        },
      }
    );
  };

  return (
    <button
      onClick={handleClick}
      disabled={toggleFavorite.isPending}
      className={cn(
        'p-1 rounded transition-colors',
        isFavorite
          ? 'text-amber-500 hover:text-amber-600'
          : 'text-tertiary hover:text-amber-500',
        className
      )}
      title={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
    >
      <Star
        className={cn('transition-all', isFavorite && 'fill-current')}
        size={size}
      />
    </button>
  );
};
